import React, { useState, useEffect } from "react";
import { EnumAlign } from "../../Config/config";
import { Transformer, Image } from "react-konva";
import helper_functions from "../../Config/helper_functions";

const LogoImage = ({
  setActive,
  imageProperties,
  setImageProperties,
  isSelected,
  onSelect,
  differenceFactor,
  id,
  active,
  xCordsOfMainImage,
  yCordsOfMainImage,
  canvasImageHeight,
  canvasImageWidth,
  onUnselect,
  canvasWidth,
  draggable,
  scaleFactorMax,
  setImageCanvasExceededDispatch,
}) => {
  if (imageProperties.tag === 8);
  const [xCords, setXCords] = useState(imageProperties.x);
  const [yCords, setYCords] = useState(imageProperties.y);
  const [containerHight, setContainerHight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);

  // ****************************************** Removed to fix image positioning issue ***
  // useEffect(() => {
  // 	setImageProperties({
  // 		x: xCords,
  // 		y: yCords,
  // 		id: imageProperties.id,
  // 		alignEnable: imageProperties.alignEnable,
  // 		scaleX: imageProperties.scaleX,
  // 		scaleY: imageProperties.scaleY,
  // 	});
  // }, [xCords, yCords]);
  // *************************************************************************************

  useEffect(() => {
    if (
      xCords &&
      yCords &&
      xCords !== 0 &&
      yCords !== 0 &&
      (xCords !== imageProperties.x || yCords !== imageProperties.y)
    ) {
      setImageProperties({
        x: xCords,
        y: yCords,
        id: imageProperties.id,
        alignEnable: imageProperties.alignEnable,
        scaleX: imageProperties.scaleX,
        scaleY: imageProperties.scaleY,
      });
    }
  }, [xCords, yCords]);

  const shapeRef = React.useRef();
  const trRef = React.useRef();
  useEffect(() => {
    if (imageProperties.image) {
      // you many need to reapply cache on some props changes like shadow, stroke, etc.
      shapeRef.current.cache();
      setContainerHight(shapeRef.current.height());
      setContainerWidth(shapeRef.current.width());
    }
  }, [imageProperties.image]);

  useEffect(() => {
    //calculating the X and Y cordinates of logo image. as canvas size and image size is different and we want the logo to be on exect position as it was on canvas
    //because canvas size is different and there is some white space either vertically or horizontaly so elwe need to subtract those pixels and then multiply with the scale the main image was resized

    helper_functions.alignment(
      0,
      imageProperties,
      shapeRef,
      helper_functions.degToRad,
      getCenterPoint,
      yCordsOfMainImage,
      xCordsOfMainImage,
      differenceFactor,
      canvasImageHeight,
      canvasImageWidth,
      setYCords,
      setXCords,
      helper_functions.newPoints
    );
  }, [imageProperties.alignEnable]);

  useEffect(() => {
    let x = parseInt(
        imageProperties.x - getCenterPoint().x * imageProperties.scaleX
      ),
      y = parseInt(
        imageProperties.y - getCenterPoint().y * imageProperties.scaleY
      );

    if (
      x + 2 < xCordsOfMainImage ||
      x + containerWidth * imageProperties.scaleX >
        canvasImageWidth + xCordsOfMainImage ||
      y < yCordsOfMainImage ||
      y + containerHight * imageProperties.scaleY >
        canvasImageHeight + yCordsOfMainImage
    ) {
      setImageCanvasExceededDispatch(true);
    } else {
      setImageCanvasExceededDispatch(false);
    }
  }, [imageProperties.x, imageProperties.y]);

  useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected, imageProperties.deg]);

  function getCenterPoint() {
    const centerPoint = {
      x: imageProperties.image.width / 2,
      y: imageProperties.image.height / 2,
      deg: imageProperties.deg,
    };
    return centerPoint;
  }
  const boundBoxFunc = (oldBox, newBox) => {
    // custom calculation for the new boundary box
    const { width, height } = newBox;
    const minWidth = canvasWidth * 0.01; // minimum width of the image
    const minNewSize = Math.min(Math.abs(height), Math.abs(width));

    // if (Math.abs(newHeight) > maxHeight || Math.abs(newWidth) > maxWidth || Math.abs(newHeight) < minHeight || Math.abs(newWidth) < minWidth)
    if (minNewSize < minWidth) {
      return oldBox;
    } else {
      return newBox;
    }
  };

  useEffect(() => {
    if (shapeRef && shapeRef.current) {
      var sizeOfContainer = parseFloat(
        Math.max(containerHight, containerWidth).toFixed(3)
      );

      let scaleFactor = shapeRef.current.width();
      scaleFactor = canvasWidth / scaleFactor;

      scaleFactorMax(
        {
          id: imageProperties.id,
          scaleFactor: scaleFactor * 2,
          sizeOfContainer,
          containerHight,
          containerWidth,
        },
        "logoImage"
      );
    }
  }, [shapeRef, containerHight, containerWidth]);

  return (
    <>
      {imageProperties.image ? (
        <Image
          id="images"
          onClick={() => {
            if (active !== id) {
              onSelect(id);
              setActive(
                imageProperties.property === "sticker"
                  ? "image"
                  : imageProperties.property
              );
              setImageProperties({
                id: imageProperties.id,
                x: imageProperties.x,
                y: imageProperties.y,
                scaleX: imageProperties.scaleX,
                scaleY: imageProperties.scaleY,
              });
            } else {
              onUnselect();
              setActive("");
            }
          }}
          // keepRatio={true}
          onTap={onSelect}
          ref={shapeRef}
          rotation={imageProperties.deg}
          x={xCords}
          y={yCords}
          scaleX={
            imageProperties.scaleXSlide
              ? imageProperties.scaleXSlide
              : imageProperties.scaleX
          }
          scaleY={
            imageProperties.scaleYSlide
              ? imageProperties.scaleYSlide
              : imageProperties.scaleY
          }
          image={imageProperties.image}
          draggable={imageProperties.property !== "template" && draggable}
          offsetX={getCenterPoint().x}
          offsetY={getCenterPoint().y}
          opacity={imageProperties.opacity}
          onDragStart={(e) => {
            onSelect(id);
            setActive(
              imageProperties.property === "sticker"
                ? "image"
                : imageProperties.property
            );
            setImageProperties({
              alignEnable: EnumAlign.None,
              x: e.target.attrs.x,
              y: e.target.attrs.y,
              id: imageProperties.id,
              scaleX: e.target.attrs.scaleX,
              scaleY: e.target.attrs.scaleY,
            });
          }}
          onDragEnd={(e) => {
            setXCords(e.target.attrs.x);
            setYCords(e.target.attrs.y);
            setImageProperties({
              x: e.target.attrs.x,
              alignEnable: EnumAlign.None,
              y: e.target.attrs.y,
              id: imageProperties.id,
              scaleX: e.target.attrs.scaleX,
              scaleY: e.target.attrs.scaleY,
            });
          }}
          onTransform={(e) => {
            // transformer is changing scale of the node
            // and NOT its width or height

            setImageProperties({
              ...imageProperties,
              type: "image",
              deg: e.target.attrs.rotation,
              scaleXTransform: parseFloat(e.target.attrs.scaleX),
              scaleYTransform: parseFloat(e.target.attrs.scaleY),
              id: imageProperties.id,
              x: e.target.attrs.x,
              y: e.target.attrs.y,
              alignEnable: EnumAlign.None,
            });
          }}
          onTransformEnd={(e) => {
            // transformer is changing scale of the node
            // and NOT its width or height

            setImageProperties({
              type: "image",
              deg: e.target.attrs.rotation, //deg is the angle of rotation
              scaleX: parseFloat(e.target.attrs.scaleX),
              scaleY: parseFloat(e.target.attrs.scaleY),
              id: imageProperties.id,
              x: e.target.attrs.x,
              y: e.target.attrs.y,
              alignEnable: EnumAlign.None,
            });
          }}
          globalCompositeOperation="source-over"
        />
      ) : null}
      {isSelected && (
        <Transformer
          ref={trRef}
          rotateEnabled
          anchorFill="white"
          anchorStroke="black"
          anchorStrokeWidth={1}
          anchorSize={8}
          borderDash={[4, 3]}
          borderDashOffset={0}
          borderEnabled
          borderStroke="#F2526F"
          borderStrokeWidth={2}
          padding={0}
          anchorCornerRadius={4}
          rotateAnchorOffset={20}
          keepRatio={true}
          enabledAnchors={[
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right",
          ]}
          boundBoxFunc={boundBoxFunc}
          flipEnabled={false}
        />
      )}
    </>
  );
};

export default LogoImage;
